import React from 'react'
import { connect } from 'react-redux'
import {
  ErrorBoundary,
  Icon,
  Retirement,
  Education,
  Holidays,
  Purchase,
  Freedom,
} from 'components'
import { deleteGoal, setActiveGoal, setGoalProp } from 'store/actions'
import { getReturnProfiles } from 'store/selectors'

function Router(props) {
  switch (props.goal.category) {
    case 'retirement':
      return <Retirement {...props} />
    case 'education':
      return <Education {...props} />
    case 'holidays':
      return <Holidays {...props} />
    case 'purchase':
      return <Purchase {...props} />
    case 'freedom':
      return <Freedom {...props} />
    default:
      return <div />
  }
}

function Edit(props) {
  const { setActiveGoal, history, goal } = props
  return (
    <section className="edit-goal">
      <ErrorBoundary>
        <div>
          <div>
            <h5>EDIT {goal.title} GOAL</h5>
            <Icon
              name="bin-danger"
              onClick={() =>
                history.push(`${history.location.pathname}/delete`)
              }
            />
          </div>
          <Icon
            name="cancel-black"
            small
            onClick={() => {
              history.replace('/')
              setActiveGoal(null)
            }}
          />
        </div>
        <div className="form">{Router(props)}</div>
      </ErrorBoundary>
    </section>
  )
}

export default connect(
  state => ({
    profile: state.profile,
    goal: state.goals[state.activeGoal],
    returnProfiles: getReturnProfiles(),
  }),
  { deleteGoal, setActiveGoal, setGoalProp }
)(Edit)



// WEBPACK FOOTER //
// ./src/components/layout/Edit.js